module.exports = __webpack_public_path__ + "img/Wigo_icons_redesign_engine.0f6b0d0c.svg";